import { render, staticRenderFns } from "./Outgoing.vue?vue&type=template&id=6bff0bf4&scoped=true"
import script from "./Outgoing.vue?vue&type=script&lang=js"
export * from "./Outgoing.vue?vue&type=script&lang=js"
import style0 from "./Outgoing.vue?vue&type=style&index=0&id=6bff0bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bff0bf4",
  null
  
)

export default component.exports